import React, { useState } from "react";

import { useTranslation } from "react-i18next";
import { useInterval } from "react-use";
import "./styles.less";

export const IdentifyReason = (props) => {
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(1);
  // useInterval(() => {
  //   if (currentIndex < 1) {
  //     setCurrentIndex(currentIndex + 1);
  //   } else {
  //     setCurrentIndex(0);
  //   }
  // }, 5000);
  return (
    <div>
      <section className="identify-reason">
        <div
          style={{
            boxShadow: "0px 4px 40px rgba(0, 0, 0, 0.2)",
            paddingTop: 120,
          }}
        >
          <div className="inner basic-column">
            <div className="title">{t("identify.identifyReason.title")}</div>
            <div className="subtitle">
              {t("identify.identifyReason.subtitle1")}
            </div>
            <div className="subtitle" style={{ marginBottom: 60 }}>
              {t("identify.identifyReason.subtitle2")}
            </div>
            <div className="identify-card-tab ">
              {[
                t("identify.identifyReason.tab1"),
                t("identify.identifyReason.tab2"),
              ].map((item, index) => (
                <div
                  className={
                    currentIndex === index ? "tab-item active" : "tab-item"
                  }
                  onClick={() => setCurrentIndex(index)}
                >
                  {item}
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="inner basic-column">
          <div className="identify-card-warp">
            <div className="identify-card-img">
              <img
                src={t(`identify.identifyReason.bg${currentIndex + 1}`)}
                alt="authing"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
